/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { Column } from '../../../../mol-data/db';
export var EntitySubtype = Column.Schema.Aliased(Column.Schema.Str(''));
//# sourceMappingURL=common.js.map